import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  EPageLayout,
  ITab,
  PageLayoutComponent,
  TabNavigationComponent,
  TabNavigationStateService,
  tabNavigationStateServiceInjectionToken,
  IconComponent
} from "@zaeper/angular-dashboard-view-lib";
import { ZDictionaryPipe } from "@zaeper/angular-localization-lib";
import { MenuItem } from "primeng/api";
import { UserPropertiesTabComponent } from "./tabs/user-properties-tab/user-properties-tab.component";
import { PaymentOptionsTabComponent } from "./tabs/payment-options-tab/payment-options-tab.component";
import { ActivitiesTabComponent } from "./tabs/activities-tab/activities-tab.component";
import { TwoFactorTabComponent } from "./tabs/two-factor-tab/two-factor-tab.component";
import { ZTemplateDirective } from "@zaeper/angular-core-lib";

@Component({
  selector: 'app-user-settings-page',
  templateUrl: './user-settings-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PageLayoutComponent,
    TabNavigationComponent,
    IconComponent,
    ZDictionaryPipe,
    UserPropertiesTabComponent,
    PaymentOptionsTabComponent,
    ActivitiesTabComponent,
    TwoFactorTabComponent,
    ZTemplateDirective
],
  providers: [
    {
      provide: tabNavigationStateServiceInjectionToken,
      useClass: TabNavigationStateService
    }
  ]
})
export class UserSettingsPageComponent {
  public readonly ePageLayout: typeof EPageLayout = EPageLayout;

  public readonly navigation: MenuItem[] = [
    {
      icon: 'pi pi-home',
      routerLink: '/de/',
    },
    {
      label: 'Einstellungen',
      routerLink: '/de/user-settings',
    }
  ];

  public tabs: ITab[] = [
    {
      title: "Konto",
      subject: "account"
    },
    {
      title: "Sicherheit",
      subject: "security"
    },
    {
      title: "Zahlungsoptionen",
      subject: "payment"
    },
    {
      title: "Aktivitäten",
      subject: "activities"
    }
  ]
}
